import { Box, Card, HStack, Text, VStack } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import MailboxCard from '../cards/MailboxCard';
import AddMailboxCard from '../cards/AddMailboxCard';
import { IMailbox, IMailboxSession } from '../types';
import { useQuery, useSubscription } from '@apollo/client';
import { MAILBOXES } from '@/api/queries';
import { MAILBOX_SESSION_UPDATED } from '@/api/subscriptions';

const MailboxCardsSection = () => {
    const { subscribeToMore, data } = useQuery(MAILBOXES, { fetchPolicy: 'network-only' });

    useEffect(()=>{
        if (data) {
            const unsubscribe = subscribeToMore({
              document: MAILBOX_SESSION_UPDATED,
              updateQuery: (prev, { subscriptionData }) => {
                if (!subscriptionData.data) return prev;

                console.log('subscriptionData', subscriptionData.data)
                const newIttems = subscriptionData.data.mailboxSessionUpdated;
      
                return Object.assign({}, prev, {
                    mailboxes: newIttems,
                });
              },
            });
      
            return () => {
              unsubscribe();
            };
        }
    },[data,subscribeToMore])

    return (
        <HStack gap={5} alignItems='start' flexWrap={'wrap'}>
            {(data?.mailboxes as IMailbox[])?.map((mailbox, i) => (
                <MailboxCard mailbox={mailbox} key={i}/>
            ))
            }
            <AddMailboxCard />
        </HStack>
    )
}

export default MailboxCardsSection;